import { CreateInstance } from "./config"
const approvalLine = CreateInstance("approval/approval-line")
const approvalManager = CreateInstance("approval/manager")
const approvalAgent = CreateInstance("approval/agent")
export default { approvalLine, approvalManager, approvalAgent }
